<template>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>Title</th>
        <th>Type</th>
        <th>Tags</th>
        <th>Candidate</th>
        <th>ARN</th>
        <th>Version</th>
        <th>Modified</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="scannedRecordList && scannedRecordList.length == 0">
        <td colspan="8">
          <no-results-found
            title="No Results Found"
            message="Maybe change the search and filters and try again?"
          ></no-results-found>
        </td>
      </tr>
      <tr
        v-else
        v-for="record in scannedRecordList"
        v-bind:key="record.id"
      >
        <td>
          <div class="btn-group">
            <a v-bind:href="record.document">
              <button class="btn-small btn-link u-no-padding">
                <span class="icon">
                  <i
                    class="fa-wrapper fa fa-download"
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </a>
            <router-link v-bind:to="{
               name: 'scanned-record-update',
               params: { id: record.id }
             }">
              <button class="btn-small btn-info u-no-padding">
                <span class="icon">
                  <i
                    class="fa-wrapper fa fa-external-link-alt"
                    aria-hidden="true"
                  ></i>
                </span>
              </button>
            </router-link>
          </div>
        </td>
        <td>{{ record.title }}</td>
        <td>
          <div v-if="record.record_type" class="tag tag--dark">
            <strong>{{ record.record_type.label }}</strong>
          </div>
        </td>
        <td>
          <scanned-record-tags
            v-if="record.tags"
            v-bind:tags="record.tags"
          ></scanned-record-tags>
        </td>
        <td>{{ record.candidate.full_name }}</td>
        <td>{{ record.candidate.arn }}</td>
        <td>{{ record.version }}</td>
        <td>{{ formatDateTime(record.modified) }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import ScannedRecordTags from "@/components/records/ScannedRecordTags";
import NoResultsFound from "@/components/PlaceholderNoResults";
import { DateTimeFormatter } from "@/functions/dateTimeFormat.function";

export default {
  name: "scanned-record-table",
  props: ["scannedRecordList"],
  components: {
    ScannedRecordTags,
    NoResultsFound,
  },
  methods: {
    formatDateTime: function(value) {
      return DateTimeFormatter(value);
    },
  }
}
</script>
